const  DynamicDataTable = ({ data = [] }) => {
  if (!data.length) {
    return (
      <div className="bg-white rounded-2xl border p-8 text-center text-slate-500">
        No records found
      </div>
    );
  }

  const columns = Object.keys(data[0]);

  return (
    <div className="bg-white rounded-2xl border overflow-hidden">

      {/* Header */}
      <div className="px-6 py-4 border-b bg-slate-50">
        <h3 className="font-semibold text-slate-800">
          Transaction Details
        </h3>
      </div>

      {/* Table */}
      <div className="overflow-auto max-h-[700px]">

        <table className="min-w-max w-full text-sm">

          <thead className="sticky top-0 bg-slate-100 z-10">
            <tr>
              {columns.map((column) => (
                <th
                  key={column}
                  className="px-4 py-3 text-left font-semibold text-slate-700 border-b whitespace-nowrap"
                >
                  {column}
                </th>
              ))}
            </tr>
          </thead>

          <tbody>
            {data.map((row, rowIndex) => (
              <tr
                key={rowIndex}
                className="hover:bg-blue-50 transition"
              >
                {columns.map((column) => {
                  const value = row[column];

                  const isMismatchColumn =
                    column.startsWith("c_");

                  const isMismatch =
                    value === "FALSE" ||
                    value === false;

                  return (
                    <td
                      key={column}
                      className={`
                        px-4 py-3 border-b whitespace-nowrap
                        ${
                          isMismatchColumn && isMismatch
                            ? "bg-red-50 text-red-600 font-medium"
                            : ""
                        }
                      `}
                    >
                      {value === null ||
                      value === undefined
                        ? "-"
                        : String(value)}
                    </td>
                  );
                })}
              </tr>
            ))}
          </tbody>

        </table>
      </div>
    </div>
  );
};

export default DynamicDataTable;